/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import ContactFormPage from './ContactFormPage'
import ContactListPage from './ContactListPage'
import { RouteObject } from 'react-router'

export const contactRoutes: RouteObject[] = [
  {
    index: true,
    element: <ContactListPage />
  },
  {
    path: 'create',
    element: <ContactFormPage />
  },
  {
    path: ':id/*',
    children: [
      {
        path: 'edit',
        element: <ContactFormPage />
      }
    ]
  }
]
